import { PmoCard, PmoCardHeader } from './ui/PmoCard';

export function BriefingNotesCard({ description, remarks }: { description?: string; remarks?: string }) {
  if (!description && !remarks) return null;
  return (
    <PmoCard>
      <PmoCardHeader title="Briefing notes" />
      <div className="space-y-3 px-4 py-3 text-[12px] leading-relaxed text-slate-600">
        {description && <p className="whitespace-pre-wrap">{description}</p>}
        {remarks && (
          <div>
            <p className="mb-1 text-[10px] font-bold uppercase tracking-[0.08em] text-[#94a3b8]">Remarks</p>
            <p className="whitespace-pre-wrap">{remarks}</p>
          </div>
        )}
      </div>
    </PmoCard>
  );
}
